import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { ValueBreakdown } from './ui/ValueBreakdown';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const baseIncludes = ['5 Tomos', '250+ páginas', '5 Bonos', 'Fichas de Pista', 'Radar del Alumno', 'Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
const kitIncludes = ['Todo Maestro en Pista', 'Los 5 Tomos', 'Los 5 Bonos', 'El Mapa de Pista', '50 Esquemas Técnicos', 'Programador 12 Meses'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-261" data-mp="2u1yvzpt7gnj4">
      <Container data-id="element-262" data-mp="2z34slypzkuxx">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-263" data-mp="2z0ik9wv9uben">
          <SectionTag tone="lime" data-id="element-264" data-mp="3thpefhweohc3">Elige cómo quieres trabajar</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-265" data-mp="3ohjvqr846565">
            Dos opciones. Un mismo objetivo: dejar de improvisar.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-266" data-mp="3fi6l3v897aju">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-7 md:p-8" data-id="element-267" data-mp="g2jdeoyoeavm">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-268" data-mp="29tmq787chs6">Maestro en Pista</p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-269" data-mp="yu2e2p589cuh">Para aprender y aplicar el sistema</p>

            <ul className="mt-6 space-y-2.5" data-id="element-270" data-mp="u0zlaj89y7fc">
              {baseIncludes.map(item => <CheckItem key={item} data-id="element-271" data-mp="2oaxz0llmhumq">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-272" data-mp="2t7ocd161mc4g" />

            <ValueBreakdown lines={[{
            label: 'Colección 5 Tomos',
            value: '35,50€'
          }, {
            label: 'Los 5 Bonos Estratégicos',
            value: '25,50€'
          }]} totalLabel="Valor total" totalValue="61€" finalPrice="17,90 €" discountPercent="71%" priceTone="white" data-id="element-273" data-mp="2tassmwws8ybh" />

            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="w-full" showArrow data-id="element-274" data-mp="2ag5bazvkx852">
              Quiero la versión base
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-275" data-mp="20l3mk557u830" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="relative flex flex-col rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-8" data-id="element-276" data-mp="3pz8fgl8ictkw">
            <span className="absolute -top-3 left-7 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-277" data-mp="1e9k6nhp417b6">
              Recomendado para monitores en activo
            </span>

            <p className="mt-2 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-278" data-mp="220y0js2wtay9">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-279" data-mp="1xzclq16temlf">Para tener el sistema + la infraestructura</p>

            <ul className="mt-6 space-y-2.5" data-id="element-280" data-mp="2bym2b1yxnipx">
              {kitIncludes.map(item => <CheckItem key={item} data-id="element-281" data-mp="2713sl9d3czgv">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-282" data-mp="hlw9yoo7qhkn" />

            <ValueBreakdown lines={[{
            label: 'Todo lo anterior',
            value: '61€'
          }, {
            label: 'Kit de Ejecución',
            value: '25,90€'
          }]} totalLabel="Valor total" totalValue="86,90€" finalPrice="23,90 €" discountPercent="73%" priceTone="lime" data-id="element-283" data-mp="cm9nrpqepqzp" />
            <p className="-mt-4 mb-4 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-284" data-mp="nzjsz1bh48el">
              Solo 6 € más que la versión base
            </p>

            <CTAButton href={KIT_CHECKOUT_URL} className="w-full" showArrow data-id="element-285" data-mp="3rjo1cofpyunq">
              Quiero el sistema completo
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-286" data-mp="9pgwlyzanve" />
          </motion.div>
        </div>
      </Container>
    </section>;
}